<template>
  <v-card height="100%">
    <v-card-title class="pb-0 text-truncate subtitle-1 font-weight-bold">
      {{ coreCard.startDate | monthYearNoTz }} -
      {{ coreCard.endDate | monthYearNoTz }}
    </v-card-title>
    <v-card-text
      :class="{
        'pb-0': true,
        'core-card-body': true
      }"
    >
      <template v-if="coreCard">
        <template v-if="coreCard.isEmpty">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                :src="$images.CORE_CARD_NO_DATA"
                height="125"
                contain
                v-bind="attrs"
                v-on="on"
              ></v-img>
            </template>
            <span class="pa-2">
              There is no data to display yet
            </span>
          </v-tooltip>
        </template>
        <template v-else-if="coreCard.excludeFromRanking">
          <v-row>
            <v-col cols="12">
              <span class="text-h4" style="opacity: 0;">Anonymity Limit</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto">
              <v-img :src="$images.PULSE_ICON"></v-img>
            </v-col>
            <v-col>
              <div class="subtitle-1 font-weight-medium">Anonymity Limit</div>
              <div>Data is hidden due to segment size</div>
            </v-col>
          </v-row>
        </template>
        <v-row class="fill-height">
          <core-card-enps
            v-if="!coreCard.isEmpty"
            :coreCard="coreCard"
          ></core-card-enps>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CoreCardEnps from "@/components/corecard/CoreCardEnps";
export default {
  name: "EnpsTrendCard",
  components: {
    CoreCardEnps
  },
  props: {
    coreCard: { type: Object }
  },
  data: () => ({
    loading: false,
    tooltip: false
  }),
  computed: {
    title() {
      return "[put title here]";
    },
    ...mapGetters({ profile: "profile/profile", settings: "profile/settings" })
  }
};
</script>

<style lang="scss" scoped>
.core-card-body {
  height: 190px;
}
</style>
